import React, { useState,useEffect } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Grid,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Box,
  Alert,
  Chip,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,CircularProgress,
  CardContent
} from '@mui/material';
import { CheckCircle, PersonAdd } from '@mui/icons-material';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const EmployeeIDForm = ({open,onClose,candidateData}) => {
  const [formData, setFormData] = useState({
      candidatename: '',
    personalemail: '',
    employmentStatus: '',
    department: '',
    designation: '',
    joiningDate: '',
    roleType: '',
    reportingManager: '',
    teamSize: '',
    selectedResponsibilities: [],
    additionalResponsibilities: ''
  });
  useEffect(() => {
    if (candidateData) {
      setFormData(prev => ({
        ...prev,
          candidatename: candidateData.name || '',
        personalemail: candidateData.candidateEmail || '',
        designation: candidateData.positionApplied || ''
      }));
    }
  }, [candidateData]);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [customDepartment, setCustomDepartment] = useState('');
  const [customRoleType, setCustomRoleType] = useState('');

  const roleTypes = [
    "CEO", "CTO", "Board of directors", "Section manager/Department manger", 
    "Manager", "Project Manager", "Product Manager", "Product Owner", "Finance Manager", "HR", "HR Manager", "Hiring Manager", "Priciple engineer/architect", 
    "Team Lead", "Senior Software Engineer", "Software Engineer", 
    "Junior Software Engineer", "Intern"
  ];

  const employmentStatusOptions = [
    "Active", "Deceased","Resigned"
  ];

  const departmentOptions = [
    "Engineering", "Human Resources", "Sales", "Marketing", 
    "Finance", "Operations", "Product", "Customer Support"
  ];

  const responsibilities = {
    "ceo": ["Strategic planning", "Business development", "Executive leadership", "Stakeholder relations", "Company vision"],
    "cto": ["Technology strategy", "Technical leadership", "Innovation management", "IT governance", "Technical risk assessment"],
    "board of directors": ["Corporate governance", "Strategic oversight", "CEO supervision", "Financial accountability", "Shareholder representation"],
    "section manager/department manger": ["Departmental leadership", "Budget management", "Cross-team coordination", "Department KPI tracking", "Process improvement"],
    "manager": ["Team management", "Project oversight", "Performance evaluation", "Resource allocation", "Department strategy"],
    "hr manager": ["Employee relations", "HR policy development", "Benefits administration", "Employee engagement", "Talent development"],
    "hiring manager": ["Candidate screening", "Interview coordination", "Recruitment strategy", "Onboarding oversight", "Hiring decisions"],
    "priciple engineer/architect": ["System architecture design", "Technical decision-making", "Engineering standards", "Technical mentorship", "Technology roadmap"],
    "team lead": ["Team coordination", "Technical guidance", "Sprint planning", "Progress reporting", "Code reviews"],
    "senior software engineer": ["Complex feature implementation", "Architecture participation", "Technical mentoring", "Advanced problem solving", "Code quality enforcement"],
    "software engineer": ["Software development", "Problem solving", "Code testing", "Documentation", "Feature implementation"],
    "junior software engineer": ["Basic feature implementation", "Bug fixing", "Learning codebase", "Pair programming", "Testing and QA"],
    "intern": ["Learning", "Assigned tasks", "Progress reporting", "Skill development", "Support activities"]
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleResponsibilityChange = (responsibility) => {
    setFormData(prev => {
      const current = prev.selectedResponsibilities;
      if (current.includes(responsibility)) {
        return {
          ...prev,
          selectedResponsibilities: current.filter(r => r !== responsibility)
        };
      } else {
        return {
          ...prev,
          selectedResponsibilities: [...current, responsibility]
        };
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    const finalFormData = {
      ...formData,
      department: formData.department === 'Other' ? customDepartment.trim() : formData.department,
      roleType: formData.roleType === 'Other' ? customRoleType.trim() : formData.roleType
    };

    try {
       const token = localStorage.getItem("token"); // get JWT token
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      const response = await fetch(`${API_URL}/api/alldetails/empdetails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(finalFormData)
      });

      const result = await response.json();

      if (result.success) {
        setSubmittedData({
          employeeId: result.data.employee_id,
          companyemail:result.data.companyemail,
        });
        setSubmitSuccess(true);
      } else {
        setError(result.message || 'Failed to add employee');
      }
    } catch (err) {
      setError('An error occurred while submitting the form');
      //console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    if (!open) {
      setFormData({
          candidatename: '',
        personalemail: '',
        employmentStatus: '',
        department: '',
        designation: '',
        joiningDate: '',
        roleType: '',
        reportingManager: '',
        teamSize: '',
        selectedResponsibilities: [],
        additionalResponsibilities: ''
      });
      setCustomDepartment('');
      setCustomRoleType('');
      setSubmitSuccess(false);
      setError('');
    }
  }, [open]);
  const handleCloseDialog = () => {
    setSubmitSuccess(false);
    onClose();
  };

  const availableResponsibilities = formData.roleType 
    ? responsibilities[formData.roleType.toLowerCase()] || []
    : [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      scroll="paper"
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <PersonAdd sx={{ mr: 1, fontSize: 32, color: 'primary.main' }} />
          <Typography variant="h5">Add New Employee</Typography>
        </Box>
        {candidateData && (
          <Typography variant="subtitle1" color="text.secondary">
            Adding: {candidateData.name} - {candidateData.positionApplied}
          </Typography>
        )}
      </DialogTitle>

      <DialogContent dividers>
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* Personal Information */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom color="primary">
                Personal Information
              </Typography>
            </Grid>
<Grid item xs={12}>
  <TextField
    fullWidth
    label="Candidate Name"
    name="candidatename"
    value={formData.candidatename}
    variant="outlined"
    InputProps={{ readOnly: true }}
  />
</Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                type="email"
                label="Personal Email"
                name="personalemail"
                value={formData.personalemail}
                onChange={handleInputChange}
                variant="outlined"
              />
            </Grid>

            {/* Employment Details */}
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom color="primary">
                Employment Details
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>Employment Status</InputLabel>
                <Select
                  name="employmentStatus"
                  value={formData.employmentStatus}
                  onChange={handleInputChange}
                  label="Employment Status"
                >
                  {employmentStatusOptions.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>Department</InputLabel>
                <Select
                  name="department"
                  value={formData.department}
                  onChange={handleInputChange}
                  label="Department"
                >
                  {departmentOptions.map((dept) => (
                    <MenuItem key={dept} value={dept}>
                      {dept}
                    </MenuItem>
                  ))}
                  <MenuItem value="Other">Other (Custom Department)</MenuItem>
                </Select>
              </FormControl>
              {formData.department === 'Other' && (
                <TextField
                  fullWidth
                  required
                  label="Custom Department"
                  value={customDepartment}
                  onChange={(e) => setCustomDepartment(e.target.value)}
                  variant="outlined"
                  sx={{ mt: 2 }}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label="Designation"
                name="designation"
                value={formData.designation}
                onChange={handleInputChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                type="date"
                label="Joining Date"
                name="joiningDate"
                value={formData.joiningDate}
                onChange={handleInputChange}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Role Information */}
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom color="primary">
                Role Information
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>Role Type</InputLabel>
                <Select
                  name="roleType"
                  value={formData.roleType}
                  onChange={handleInputChange}
                  label="Role Type"
                >
                  {roleTypes.map((role) => (
                    <MenuItem key={role} value={role}>
                      {role}
                    </MenuItem>
                  ))}
                  <MenuItem value="Other">Other (Custom Role Type)</MenuItem>
                </Select>
              </FormControl>
              {formData.roleType === 'Other' && (
                <TextField
                  fullWidth
                  required
                  label="Custom Role Type"
                  value={customRoleType}
                  onChange={(e) => setCustomRoleType(e.target.value)}
                  variant="outlined"
                  sx={{ mt: 2 }}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Reporting Manager"
                name="reportingManager"
                value={formData.reportingManager}
                onChange={handleInputChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Team Size"
                name="teamSize"
                value={formData.teamSize}
                onChange={handleInputChange}
                variant="outlined"
                inputProps={{ min: 0 }}
              />
            </Grid>

            {/* Responsibilities */}
            {availableResponsibilities.length > 0 && (
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                  Select Responsibilities
                </Typography>
                <FormGroup row>
                  {availableResponsibilities.map((resp) => (
                    <Grid item xs={12} sm={6} md={4} key={resp}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.selectedResponsibilities.includes(resp)}
                            onChange={() => handleResponsibilityChange(resp)}
                          />
                        }
                        label={resp}
                      />
                    </Grid>
                  ))}
                </FormGroup>
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Additional Responsibilities"
                name="additionalResponsibilities"
                value={formData.additionalResponsibilities}
                onChange={handleInputChange}
                variant="outlined"
                placeholder="Enter any additional responsibilities..."
              />
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                disabled={isSubmitting}
                sx={{ mt: 2, py: 1.5 }}
              >
                {isSubmitting ? 'Submitting...' : 'Add Employee'}
              </Button>
            </Grid>
          </Grid>
        </form>
       </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} /> : <PersonAdd />}
        >
          {isSubmitting ? 'Adding Employee...' : 'Add Employee'}
        </Button>
      </DialogActions>

      {/* Success Dialog */}
      <Dialog
        open={submitSuccess}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', color: 'success.main' }}>
            <CheckCircle sx={{ mr: 1, fontSize: 32 }} />
            <Typography variant="h5">Employee Added Successfully!</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {submittedData && (
            <Card variant="outlined" sx={{ mt: 2 }}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Employee ID
                    </Typography>
                    <Chip 
                      label={submittedData.employeeId} 
                      color="primary" 
                      sx={{ mt: 0.5, fontWeight: 'bold' }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default EmployeeIDForm;